import { render, staticRenderFns } from "./te-collapsible.vue?vue&type=template&id=08432820"
import script from "./te-collapsible.vue?vue&type=script&lang=js"
export * from "./te-collapsible.vue?vue&type=script&lang=js"
import style0 from "./te-collapsible.vue?vue&type=style&index=0&id=08432820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports